import { render, staticRenderFns } from "./LiveCalls.vue?vue&type=template&id=c6349924&scoped=true&"
import script from "./LiveCalls.vue?vue&type=script&lang=js&"
export * from "./LiveCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6349924",
  null
  
)

export default component.exports